import React from "react";
import { useNavigate } from "react-router-dom";
import classes from "./PageHeader.module.css";
import Reveal from "../Reveal/Reveal";

/**
 * Masthead for the standalone listing pages.
 *
 * Replaces the previous band, which was a flat 70%-black rectangle laid over a
 * photo with a single word on it - no way back, and no sense of how much was
 * on the page.
 */
export default function PageHeader({ eyebrow, title, image, meta }) {
  const navigate = useNavigate();

  return (
    <header className={classes.header}>
      <div className={classes.media}>
        <img src={image} alt="" className={classes.image} />
        <span className={classes.scrim} aria-hidden="true" />
      </div>

      <Reveal className={classes.inner} selector="[data-line]" stagger={0.07} y={24}>
        <button
          type="button"
          className={classes.back}
          onClick={() => navigate("/")}
          data-line
        >
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path
              d="M13 8H4M8 4L4 8l4 4"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Back to home</span>
        </button>

        <div className={classes.titleRow} data-line>
          <div>
            {eyebrow && <span className={classes.eyebrow}>{eyebrow}</span>}
            <h1 className={classes.title}>{title}</h1>
          </div>
          {meta && <span className={classes.meta}>{meta}</span>}
        </div>
      </Reveal>
    </header>
  );
}
